import { Order } from '@cemex-core/cmx-api/models/order-management/order';
import { RepeatOrderActions, RepeatOrderActionTypes } from '../actions/repeat-order.actions';
import { IRepeatOrderValidationResponse } from '@cemex-core/cmx-api/models/repeat-order-validation/repeat-order-validation-res';
import { PatchOrderRequestedResponse, UpdatePatchResponse } from '@cemex-core/cmx-api/public_api';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';

export interface IRepeatOrderState {
  loading: boolean;
  orderDetail: Order;
  validation: IRepeatOrderValidationResponse;
  newOrderId: string;
  experience: ORDER_EXPERIENCES;
  error: boolean;
}

export const initialState: IRepeatOrderState = {
  loading: true,
  validation: null,
  orderDetail: null,
  newOrderId: null,
  experience: null,
  error: false,
};

export function reducer(state = initialState, action: RepeatOrderActions): IRepeatOrderState {
  switch (action.type) {
    case RepeatOrderActionTypes.TOGGLE_LOADER: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case RepeatOrderActionTypes.LOAD_FAIL: {
      return {
        ...state,
        orderDetail: null,
      };
    }
    case RepeatOrderActionTypes.LOAD_SUCCESS: {
      return {
        ...state,
        orderDetail: action.payload,
      };
    }
    case RepeatOrderActionTypes.REPEAT_ORDER_VALIDATION_RESPONSE: {
      return {
        ...state,
        validation: action.payload,
      };
    }
    case RepeatOrderActionTypes.REPEAT_ORDER_CREATE_ORDER_SUCCESS: {
      return {
        ...state,
        loading: false,
        newOrderId:
          (action.payload.order as UpdatePatchResponse).id ||
          (action.payload.order as PatchOrderRequestedResponse).orderId.toString(),
        experience: action.payload.experience,
      };
    }
    case RepeatOrderActionTypes.REPEAT_ORDER_CREATE_DRAFT_FAILED: {
      return {
        ...state,
        loading: false,
        error: true,
      };
    }
    case RepeatOrderActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
